// extracted by mini-css-extract-plugin
module.exports = {"SupplierServices__row":"SupplierServices_SupplierServices__row__vatwU","SupplierServices__phoneNumber":"SupplierServices_SupplierServices__phoneNumber__a2PK2"};